<script>
  import Page from '../+page.svelte'
  export let data
</script>

<Page {data} />
